import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=650a8023&"
import script from "./NotificationMessage.vue?vue&type=script&lang=ts&"
export * from "./NotificationMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports